// Workaround for: https://github.com/bazelbuild/rules_nodejs/issues/1265
/// <reference types="google.maps" />

import { createActionGroup, props } from '@ngrx/store';
import { SerializablePosition } from '@us/web/shared/data-access';

export const PositionActions = createActionGroup({
    source: 'Position',
    events: {
        'Request Position': props<{ force?: boolean }>(),
        'Request Position Success': props<{ position: SerializablePosition }>(),
        'Get Geocode': props<{ lat: number; lng: number }>(),
        'Get Geocode Success': props<{ geocode: google.maps.GeocoderResponse }>(),
        'Get Geocode Failure': props<{ error: string }>(),
        'Select Geocode': props<{ geocoderResult: google.maps.GeocoderResult }>()
    }
});
